module.exports = __webpack_public_path__ + "static/media/1POLICY49.13e62ba0.jpg";